export interface DevcontainerSpec {
  name: string;
  "devcontainer-json": string;
}
export interface Devcontainer {
  type: "omega/query-omega/devcontainer/DevContainer";
  "app-id": string;
  "devcontainer-id": string;
  "devcontainer-spec": DevcontainerSpec;
}
export type DevcontainerMap = { [k: string]: Devcontainer };
export const initDevcontainerMap: DevcontainerMap = {};
export const devcontainerName = (dc: Devcontainer | undefined): string =>
  dc?.["devcontainer-spec"]?.name ?? "";
export const devcontainerJson = (dc: Devcontainer | undefined): string =>
  dc?.["devcontainer-spec"]?.["devcontainer-json"] ?? "";
export const DEFAULT_DEVCONTAINER_JSON = JSON.stringify({ name: "Devcontainer", image: "" }, null, 2);
export const newDevcontainer = (config: {
  appId: string; devcontainerId: string; name: string; devcontainerJson?: string;
}): Devcontainer => {
  const { appId, devcontainerId, name, devcontainerJson = DEFAULT_DEVCONTAINER_JSON } = config;
  return {
    type: "omega/query-omega/devcontainer/DevContainer",
    "app-id": appId,
    "devcontainer-id": devcontainerId,
    "devcontainer-spec": { name, "devcontainer-json": devcontainerJson },
  };
};
